import { appRequest } from "routes";
import * as XLSX from "xlsx";

export function createInitialLogics(
  values: any,
  setTotalPages?: any,
  setTransformedData?: any
) {
  if (Array.isArray(values)) {
    if (Array.isArray(values[values.length - 1].values?.results)) {
      if (setTotalPages) {
        setTotalPages(values[values.length - 1].values?.pageCount || 0);
      }
      const transformed = values[values.length - 1].values?.results.map(
        (result: any) => {
          return updateOriginalValues(result.fields);
        }
      );
      if (setTransformedData) {
        setTransformedData(transformed);
      } else {
        return transformed;
      }
    }
  } else {
    if (setTotalPages) {
      setTotalPages(values?.values?.pageCount || 0);
    }

    if (Array.isArray(values?.values?.results)) {
      const transformed = values?.values?.results.map((result: any) =>
        transformToinitialOrgAndEditedFormat(result.fields)
      );
      if (setTransformedData) {
        setTransformedData(transformed);
      } else {
        return transformed;
      }
    }
  }
}

export const compareAndUpdateValues = (oldData: any, newData: any) => {
  // Function to recursively check and update values
  const updateValues = (oldObj: any, newObj: any) => {
    for (const key in newObj) {
      if (
        newObj[key] &&
        typeof newObj[key] === "object" &&
        !Array.isArray(newObj[key])
      ) {
        // If the value is an object and doesn't exist in oldObj, initialize it
        if (!oldObj[key]) oldObj[key] = {};
        // Recurse into nested object
        updateValues(oldObj[key], newObj[key]);
      } else if (Array.isArray(newObj[key])) {
        // If the value is an array, initialize it in oldObj if needed
        if (!oldObj[key]) oldObj[key] = [];
        for (let i = 0; i < newObj[key].length; i++) {
          // Ensure oldObj has an object at each index
          if (!oldObj[key][i]) oldObj[key][i] = {};
          updateValues(oldObj[key][i], newObj[key][i]);
        }
      } else if (key === "originalValues") {
        // Compare `originalValues` in old and new data
        if (oldObj[key] !== newObj[key]) {
          oldObj["editedValues"] = newObj[key];
        }
      } else {
        // If key does not exist in oldObj, add it
        if (oldObj[key] === undefined) {
          oldObj[key] = newObj[key];
        }
      }
    }
  };

  // Clone the old data to avoid mutation
  const updatedData = JSON.parse(JSON.stringify(oldData));
  updateValues(updatedData, newData);
  return updatedData;
};

function removeTopLevelOriginalValues(dataArray: any) {
  if (Array.isArray(dataArray)) {
    dataArray.forEach((item: any) => {
      // First remove the 'originalValues' key at the top level in fields
      if (item.fields && typeof item.fields === "object") {
        for (const key in item.fields) {
          if (
            key === "originalValues" &&
            (item.fields[key] === undefined || item.fields[key] === "")
          ) {
            delete item.fields[key];
          }

          // Now, check if any key in fields is an array
          if (Array.isArray(item.fields[key])) {
            item.fields[key].forEach((subItem: any) => {
              if (subItem && typeof subItem === "object") {
                // For each object inside the array, check if 'originalValues' is present and its value is empty or undefined
                if (
                  subItem.hasOwnProperty("originalValues") &&
                  (subItem["originalValues"] === undefined ||
                    subItem["originalValues"] === "")
                ) {
                  delete subItem["originalValues"];
                }
              }
            });
          }
        }
      }
    });
  }
  return dataArray;
}

export const handleSaveAllPages = (
  transformedData: any,
  values: any,
  setFinalResuts?: any,
  deletedDataIndex?: any
) => {
  // Create a deep copy to avoid direct mutation of transformedData
  const trans = transformedData.map((item: any) => ({ ...item }));

  if (Array.isArray(values)) {
    const val = values[values.length - 1].values;

    const updatedTrans = trans.map((data: any, index: number) => {
      const updatedFields = swapAndCompare(val?.results[index].fields, data);
      return {
        ...val?.results[index],
        fields: updatedFields,
      };
    });

    const dts = removeTopLevelOriginalValues(updatedTrans);

    if (setFinalResuts) {
      setFinalResuts({ pageCount: val?.pageCount, results: updatedTrans });
    }

    return { values: { pageCount: val?.pageCount, results: updatedTrans } };
  } else {
    const dts: any[] = [];
    const updatedTrans = trans.map((data: any, index: number) => {
      if (Array.isArray(data?.medicines)) {
        // Use filter to remove items with "AddNew" and add them to dts
        const filteredMedicines = data.medicines.filter((it: any) => {
          if ("AddNew" in it) {
            dts.push(it); // Add item with "AddNew" to dts
            return false; // Exclude item from medicines array
          }
          return true; // Keep item in medicines array
        });

        // Avoid directly mutating data.medicines
        data = { ...data, medicines: filteredMedicines };
      }

      const dsts = { ...values?.values?.results[index].fields };

      // Filter deleted items from medicines
      // dsts.medicines = dsts.medicines.filter(
      //   (_: any, idx: number) => !deletedDataIndex.includes(idx)
      // );

      const updatedFields = compareAndUpdateValues(
        transformToinitialOrgAndEditedFormat(dsts),
        data
      );

      return {
        ...values?.values?.results[index],
        fields: {
          medicines: Array.isArray(updatedFields.medicines)
            ? [...updatedFields.medicines, ...dts]
            : updatedFields,
        },
      };
    });

    if (setFinalResuts) {
      setFinalResuts({
        pageCount: values?.values?.pageCount,
        results: updatedTrans,
      });
    }

    return {
      values: { pageCount: values?.values?.pageCount, results: updatedTrans },
    };
  }
};

// export function updateOriginalValues(data: any): any {
//   // Iterate over each key in the data object
//   for (const key in data) {
//     if (data.hasOwnProperty(key)) {
//       const value = data[key];

//       // If the value is an object, recursively update its originalValues
//       if (typeof value === "object" && value !== null) {
//         updateOriginalValues(value);
//       }

//       // If the key is "originalValues" and "editedValues" is not null, update originalValues to match editedValues
//       else if (key === "originalValues" && data["editedValues"] !== null) {
//         data["originalValues"] = data["originalValues"] || data["editedValues"]
//       }

//       if (typeof value === "string" && value.trim() === "") {
//         data[key] = null;
//       }
//     }
//   }

//   return data;
// }

export function updateOriginalValues(data: any): any {
  if (Array.isArray(data)) {
    return data.map(updateOriginalValues);
  }

  if (typeof data === "object" && data !== null) {
    const keys = Object.keys(data);

    const isFormatted =
      keys.includes("originalValues") || keys.includes("editedValues");

    // If this object is a leaf formatted as { originalValues, editedValues }
    if (isFormatted) {
      const original = data.originalValues;
      const edited = data.editedValues;

      // Normalize empty strings to null
      data.originalValues = (original === "" ? null : original);
      data.editedValues = (edited === "" ? null : edited);

      // If edited value is not null and original is null/undefined, update original
      if (data.editedValues !== null && (data.originalValues === null || data.originalValues === undefined)) {
        data.originalValues = data.editedValues;
      }

      return data;
    }

    // Otherwise, recurse into each key
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        data[key] = updateOriginalValues(data[key]);
      }
    }

    return data;
  }

  // Base case: primitive — return as-is
  return data;
}
export function transformToinitialOrgAndEditedFormat(data: any): any {
  if (Array.isArray(data)) {
    // If the data is an array, transform each item in the array
    return data.map(transformToinitialOrgAndEditedFormat);
  } else if (typeof data === "object" && data !== null) {
    const transformedObj: any = {};

    for (const key in data) {
      const value = data[key];

      if (typeof value === "object" && value !== null) {
        // Recursively process nested objects and arrays
        transformedObj[key] = transformToinitialOrgAndEditedFormat(value);
      } else {
        // For primitive values, structure them with originalValues and editedValues
        transformedObj[key] = {
          originalValues: value,
          editedValues: null,
        };
      }
    }

    return transformedObj;
  } else {
    // If data is neither array nor object, return as primitive type
    return {
      originalValues: data,
      editedValues: null,
    };
  }
}

const getValue = (field: any): string => {
  if (Array.isArray(field)) {
    const values = field.map((item: any) => {
      if (typeof item === "object" && item !== null) {
        if (item.editedValues) {
          return item.editedValues;
        }
        if (item.originalValues) {
          return item.originalValues;
        }
      }
      return "";
    });

    return JSON.stringify(values);
  }

  if (typeof field === "object" && field !== null) {
    if (field.editedValues) {
      return field.editedValues;
    }
    if (field.originalValues) {
      return field.originalValues;
    }
    return "";
  }

  return field || "";
};

export const exportToExcel = (data: any, sendMail?: any, setFileData?: any) => {
  const pages = data?.values?.results || [];
  // call to download excel
  // exportToExcelss(pages, "medicines_dynamic.xlsx");

  const wb = XLSX.utils.book_new();
  pages.forEach((page: any) => {
    const rows: any[] = [];
    let maxCol1Length = 0;
    let maxCol2Length = 0;

    Object.keys(page.fields).forEach((key: string) => {
      const value: any = getValue(page.fields[key]);
      rows.push([key, value]);

      maxCol1Length = Math.max(maxCol1Length, key.length);
      maxCol2Length = Math.max(maxCol2Length, String(value).length);
    });

    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws["!cols"] = [{ wch: maxCol1Length + 2 }, { wch: maxCol2Length + 2 }];

    XLSX.utils.book_append_sheet(wb, ws, `Page ${page.page}`);
  });

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  const hours = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");

  const name = `DRUG_ORDER_${day}_${month}_${year}-${hours}_${minutes}`;
  let workbook: any = null;
  workbook = exportToExcelss(pages, `${name}.xlsx`, sendMail);

  let excelFile: any = null;
  if (sendMail.includes("mail")) {
    const base64 = XLSX.write(workbook, {
      type: "base64",
      bookType: "xlsx",
    });
    const base64Prefix = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`;
    setFileData(base64Prefix);
    excelFile = base64Prefix;
  }
  return excelFile;
};

const handleSubmit = async (
  fieldName: any,
  fileData: any,
  toastNotify?: any
) => {
  if (fieldName.length <= 0) {
    toastNotify({
      title: `No email found.`,
      message: "Please update.",
      type: "warning",
    });
    return;
  }
  try {
    toastNotify({
      title: `Sending Mail.`,
      message: "Please wait for a few seconds...",
      type: "info",
    });

    const response: any = await appRequest("document", "sendMail", {
      fieldName,
      fileData,
    });

    if (response && response.status === "success") {
      toastNotify({
        title: `Success`,
        message: "Mail Sent Successfully",
        type: "success",
      });
    } else {
      toastNotify({
        title: `Mail not sent.`,
        message: response?.message || "Something went wrong.",
        type: "error",
      });
    }
  } catch (error) {
    toastNotify({
      title: `Error sending mail.`,
      message: "Something went wrong.",
      type: "error",
    });
  }
};

export function addMedicinesKeyAndCleanFields(data: any) {
  if (data?.fields && typeof data.fields === "object") {
    if (Array.isArray(data.fields.medicines)) {
      // Loop through each medicine and add buy_X and get_Y if missing
      data.fields.medicines = data.fields.medicines.map((medicine: any) => ({
        ...medicine,
        UNIT_PRICE: "",
        buy_X: medicine.buy_X ?? "",
        get_Y: medicine.get_Y ?? "",
      }));
    } else {
      // If not an array, create a new medicines array with the fields
      const medicines = [
        {
          name: data.fields.name,
          dosage: data.fields.dosage,
          quantity: data.fields.quantity,
          UNIT_PRICE: "",
          buy_X: "",
          get_Y: "",
        },
      ];

      // Assign medicines array to fields and delete the individual fields
      data.fields.medicines = medicines;
      delete data.fields.name;
      delete data.fields.dosage;
      delete data.fields.quantity;
      delete data.buy_X;
      delete data.get_Y;
      delete data.UNIT_PRICE;
    }
  }
  return data;
}

const transformData = (data: any) => {
  return data.map((item: any) => {
    const transformedItem = {};

    // Recursive function to traverse and check for editedValues
    const transformObject = (obj: any) => {
      for (let key in obj) {
        // Ensure obj[key] is an object before trying to access 'editedValues'
        if (obj[key] && obj[key].hasOwnProperty('editedValues')) {
          // If editedValues exist, use that, otherwise fallback to originalValues
          obj[key] = obj[key].editedValues !== null ? obj[key].editedValues : obj[key].originalValues;
        } else if (Array.isArray(obj[key])) {
          // Handle arrays recursively
          obj[key].forEach(transformObject);
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          // Handle nested objects recursively
          transformObject(obj[key]);
        }
      }
    };

    transformObject(item);

    return item;
  });
};


// Function to export the transformed data to Excel
export const exportToExcels = (data : any) => {
  const dataCopy = JSON.parse(JSON.stringify(data));
  const transformedData = transformData(dataCopy);

  // Create a new workbook
  const wb = XLSX.utils.book_new();

  // Iterate through each object in the array, each representing a sheet
  transformedData.forEach((item : any, index : number) => {
    // Convert each object to an array of arrays (rows)
    const sheetData = Object.keys(item).map((key) => {
      return [key, item[key]];
    });

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Append the sheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, `Sheet ${index + 1}`);
  });

  XLSX.writeFile(wb, 'transformed_data.xlsx');
};

export function updateValues(data: any): any {
  if (Array.isArray(data)) {
    return data.map((item) => {
      if (
        typeof item === "object" &&
        item !== null &&
        "originalValues" in item &&
        "editedValues" in item
      ) {
        if (item.editedValues !== null) {
          item.originalValues = item.editedValues;
        }
      } else {
        return updateValues(item);
      }
      return item;
    });
  } else if (typeof data === "object" && data !== null) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (
          typeof data[key] === "object" &&
          data[key] !== null &&
          "originalValues" in data[key] &&
          "editedValues" in data[key]
        ) {
          if (data[key].editedValues !== null) {
            data[key].originalValues = data[key].editedValues;
          }
        } else if (Array.isArray(data[key])) {
          data[key] = updateValues(data[key]);
        } else {
          data[key] = updateValues(data[key]);
        }
      }
    }
  }
  return data;
}

type DynamicObject = any;

export function swapAndCompare(
  obj1: DynamicObject,
  obj2: DynamicObject
): DynamicObject {
  function processNode(node1: any, node2: any) {
    // Ensure "originalValues" exists in both nodes, setting it to "" if missing
    if (!("originalValues" in node1)) node1.originalValues = "";
    if (!("originalValues" in node2)) node2.originalValues = "";

    if (
      node1 &&
      typeof node1 === "object" &&
      node2 &&
      typeof node2 === "object" &&
      "originalValues" in node1 &&
      "originalValues" in node2 &&
      "editedValues" in node2
    ) {
      if (node2.editedValues === null) {
        const effectiveValue1 =
          node1.editedValues !== null
            ? node1.editedValues
            : node1.originalValues;

        if (effectiveValue1 !== node2.originalValues) {
          node2.editedValues = node2.originalValues;
          node2.originalValues = effectiveValue1;
        }
      } else {
        [node2.originalValues, node2.editedValues] = [
          node2.editedValues,
          node2.originalValues,
        ];
      }
    }
  }

  function recursiveTraversal(obj1: any, obj2: any) {
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      obj1.forEach((item, index) => recursiveTraversal(item, obj2[index]));
    } else if (
      obj1 &&
      typeof obj1 === "object" &&
      obj2 &&
      typeof obj2 === "object"
    ) {
      processNode(obj1, obj2);

      for (const key in obj1) {
        if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
          recursiveTraversal(obj1[key], obj2[key]);
        }
      }
    }
  }

  recursiveTraversal(obj1, obj2);
  return obj2;
}

const getDynamicHeaders = (data: any[]): string[] => {
  const allHeaders: Set<string> = new Set();

  data.forEach((page: any) => {
    if (page.fields) {
      const fieldArray = Object.values(page.fields).find((value) =>
        Array.isArray(value)
      );
      const fieldData = Array.isArray(fieldArray) ? fieldArray : [page.fields]; // Ensure array

      fieldData.forEach((item: any) => {
        Object.keys(item || {}).forEach((field: string) => {
          allHeaders.add(field);
        });
      });
    }
  });

  return Array.from(allHeaders);
};

const prepareSheetData = (data: any[], headers: string[]): any[][] => {
  const sheetData: any[][] = [];

  data.forEach((page: any) => {
    if (page.fields) {
      // Detect if fields has an array inside; otherwise, treat fields as a flat object
      const fieldArray = Object.values(page.fields).find((value) =>
        Array.isArray(value)
      );
      const fieldData = Array.isArray(fieldArray) ? fieldArray : [page.fields]; // Ensure array

      fieldData.forEach((item: any) => {
        const rowData = headers.map((header: string) => {
          return (
            item[header]?.editedValues ||
            item[header]?.originalValues ||
            item[header] ||
            ""
          );
        });
        sheetData.push(rowData);
      });
    }
  });

  return sheetData;
};

const createWorkbook = (data: any[]): XLSX.WorkBook => {
  const wb: XLSX.WorkBook = XLSX.utils.book_new();

  data.forEach((page: any) => {
    const originalHeaders: string[] = getDynamicHeaders([page]);
    const originalSheetData: any[][] = prepareSheetData(
      [page],
      originalHeaders
    );

    const headerReplacements: Record<string, string> = {
      name: "DRUG_NAME",
      dosage: "DRUG_CODE",
      quantity: "DRUG_QUANTITY",
      buy_X: "BUY_X",
      get_Y: "GET_Y",
      UNIT_PRICE: "UNIT_PRICE",
    };

    const headers = originalHeaders.map(
      (header) => headerReplacements[header] || header
    );

    const sheetData = originalSheetData.map((row) =>
      originalHeaders.map((header) => row[originalHeaders.indexOf(header)])
    );

    // const additionalHeaders = ["UNIT_PRICE", "BUY_X", "GET_Y"];
    // additionalHeaders.forEach((header) => {
    //   if (!headers.includes(header)) {
    //     headers.push(header);
    //   }
    // });

    const worksheetData = [headers, ...sheetData];
    const sheetName: string = `Page ${page.page || "1"}`;

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

    headers.forEach((_, colIdx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      if (!ws[cellAddress]) ws[cellAddress] = { t: "s", v: headers[colIdx] };
      ws[cellAddress].s = { font: { bold: true } };
    });

    const colWidths = headers.map((header, colIdx) => {
      const maxContentWidth = Math.max(
        header.length,
        ...sheetData.map((row) =>
          row[colIdx] ? row[colIdx].toString().length : 0
        )
      );
      return { wch: maxContentWidth + 2 };
    });
    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  return wb;
};

const exportToExcelss = (data: any[], fileName: string, sendMail: any) => {
  const wb = createWorkbook(data);

  if (sendMail.includes("download")) {
    XLSX.writeFile(wb, fileName);
  }
  return wb;
};
